// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PaymentProviderMethod from './data'

export default function PaymentProviderMethodFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PaymentProvider/PaymentProviderMethod">
      <PaymentProviderMethod {...props}>
        {children}
      </PaymentProviderMethod>
    </Flow>
  )
}
